import { componentClassName } from '@/styles/List';
import { StandaloneList } from 'base/components/List';
import { withNonHTMLChildren, withSafeInnerHTML } from 'lib/utils';
import mergeProps from 'lib/utils/mergeProps';
import { isArray, isArrayNotEmpty } from 'typesafe-utils';

export const AllasStandaloneList: typeof StandaloneList = ({ items, options, as, ...props }) => {
  const { $item, ...$base } = options ?? {};

  const List = as ?? 'ul';

  if (!isArray(items) || !isArrayNotEmpty(items)) {
    return null;
  }

  const listClassName = componentClassName('', {});
  const itemClassName = componentClassName('item', {});

  return (
    <List {...mergeProps({ className: listClassName }, $base)} {...props}>
      {items.map((item, i) => (
        <li key={i} {...mergeProps({ className: itemClassName }, $item)} {...withSafeInnerHTML(item)}>
          {withNonHTMLChildren(item)}
        </li>
      ))}
    </List>
  );
};

export default AllasStandaloneList;
